import {
  Download,
  FolderDown,
  Layout,
  Search,
  SlidersHorizontal,
  Trash,
  Trash2,
  X,
} from 'lucide-react';
import * as XLSX from 'xlsx';

import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  toggleColFilter,
  toggleFilterDropdown,
  updateSearchQuery,
} from '../../store/slices/filterOptionsSlice';
import { getAllCandidatesForInterviewThunk } from '../../store/thunks/InterviewThunk';
import { toast } from 'react-toastify';
import {
  buildInterviewThunkParams,
  downloadResumesZipService,
  downloadScreenedResumesZipService,
} from '../../Services/interviewManagement.service';
import {
  deleteCandidateBulkUploadService,
  deleteCandidateSourcedService,
  exportCandidatesExcelService,
} from '../../Services/CandidateManagement.service';
import { removeSelectedCandidates } from '../../store/slices/candidateManagementSlice';
import { setShowDeletePopup } from '../../store/slices/miscSlice';
import ConfirmationDialog from './ConfirmationDialog';

function FilterComponent() {
  const activeSubTab = useSelector(
    (state) => state.candidateManagementSlice.activeSubTab,
  );
  const activeTab = useSelector(
    (state) => state.candidateManagementSlice.activeTab,
  );
  const searchQuery = useSelector((state) => state.filterSlice.searchQuery);
  const filterCount = useSelector((state) => state.filterSlice.filterCount);
  const filterState = useSelector((state) => state.filterSlice);
  const org_id = useSelector((state) => state.userSlice.org_id);
  const columnVisibility = useSelector(
    (state) => state.filterSlice.columnVisibility,
  );
  const dispatch = useDispatch();
  const filterRef = useRef();
  const debounceRef = useRef(null);
  const selectedCandidates = useSelector(
    (state) => state.candidateManagementSlice.selectedCandidates,
  );
  const showDeletePopup = useSelector(
    (state) => state.miscSlice.showDeletePopup,
  );

  const selectionCount = useSelector(
    (state) => state.candidateManagementSlice.selectionCount,
  );
  const handleDebouncedSearch = (searchValue = searchQuery) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      if (activeSubTab === 'MY_UPLOADS') {
        console.log('handled In that specific page ');
      }

      if (activeTab === 'INTERVIEW') {
        // const params = buildInterviewThunkParams({
        //  filterState: { ...filterState, searchQuery: searchValue },
        //   activeSubTab,
        //   page: 1,
        //   org_id,
        // });
        // console.log({ params });
        // // const params = statusMap[activeSubTab];
        // if (params) {
        //   dispatch(getAllCandidatesForInterviewThunk(params));
        // }
        // Handlerd search in interview tab with all filters and search query as params
      }

      if (activeTab === 'DECISION') {
      }
    }, 700);
  };
  console.log({ len: selectedCandidates.length });

  useEffect(() => {
    const handleClickOutside = (e) => {
      // If click is inside the button, let the button's onClick handle it
      if (filterRef.current?.contains(e.target)) return;
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const hasResumeDownload =
    activeTab === 'INTERVIEW' ||
    activeTab === 'DECISION' ||
    (activeTab === 'SOURCED' && activeSubTab !== 'OUTREACHED');
  // The download button stays disabled until at least one candidate is selected.
  const noCandidateSelected = !selectedCandidates || selectedCandidates.length === 0;
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const downloadMenuRef = useRef(null); // wraps the trigger button
  const downloadDropdownRef = useRef(null); // the portaled menu
  const [menuPos, setMenuPos] = useState({ top: 0, right: 0 });

  useEffect(() => {
    if (!showDownloadMenu) return;

    const place = () => {
      const rect = downloadMenuRef.current?.getBoundingClientRect();
      if (rect) {
        setMenuPos({
          top: rect.bottom + 8,
          right: window.innerWidth - rect.right,
        });
      }
    };
    place();

    const closeOnOutsideClick = (e) => {
      if (
        !downloadMenuRef.current?.contains(e.target) &&
        !downloadDropdownRef.current?.contains(e.target)
      ) {
        setShowDownloadMenu(false);
      }
    };
    document.addEventListener('mousedown', closeOnOutsideClick);
    window.addEventListener('resize', place);
    window.addEventListener('scroll', place, true);
    return () => {
      document.removeEventListener('mousedown', closeOnOutsideClick);
      window.removeEventListener('resize', place);
      window.removeEventListener('scroll', place, true);
    };
  }, [showDownloadMenu]);

  const handledeletecandidateClicked = async () => {
    if (selectionCount === 0) {
      toast.error('Select at least one candidate to delete.');
      return;
    }

    if (activeSubTab === 'ALL' && selectedCandidates.length > 0) {
      const toastId = toast.loading('Deleting selected candidates...');
      try {
        // ── split by unique_id presence, not _tableSource ──
        const myUploadSelected = selectedCandidates.filter(
          (c) => !!c.unique_id,
        );
        const sourcedSelected = selectedCandidates.filter((c) => !c.unique_id);

        for (const candidate of myUploadSelected) {
          const rsp = await deleteCandidateBulkUploadService({
            uploadId: candidate.upload_id,
            emails: candidate.candidate_email,
            uniqueId: candidate.unique_id,
          });
          if (rsp) dispatch(removeSelectedCandidates([candidate]));
        }

        if (sourcedSelected.length > 0) {
          const candidateIds = sourcedSelected.map((c) => c._id);
          const rsp = await deleteCandidateSourcedService(candidateIds);
          if (rsp) dispatch(removeSelectedCandidates(sourcedSelected));
        }

        toast.update(toastId, {
          render: 'Selected candidates deleted successfully',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        });
      } catch (error) {
        toast.update(toastId, {
          render: 'Something went wrong while deleting candidates',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
      }
      return;
    }
    if (activeSubTab === 'MY_UPLOADS' && selectedCandidates.length > 0) {
      const toastId = toast.loading('Deleting selected candidates...');
      try {
        for (const candidate of selectedCandidates) {
          const rsp = await deleteCandidateBulkUploadService({
            uploadId: candidate.upload_id,
            emails: candidate.candidate_email,
            uniqueId: candidate.unique_id,
          });
          if (rsp) {
            dispatch(removeSelectedCandidates([candidate]));
          }
        }

        console.log('All selected candidates deleted successfully');
        toast.update(toastId, {
          render: 'Selected candidates deleted successfully',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        });
      } catch (error) {
        console.error('Error while deleting candidates:', error.message);
        toast.update(toastId, {
          render: 'Something went wrong while deleting candidates',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
      }
    } else if (
      activeSubTab === 'SOURCED_CANDIDATES' &&
      selectedCandidates.length > 0
    ) {
      const toastId = toast.loading('Deleting sourced candidates...');

      try {
        // extract all candidate ids
        const candidateIds = selectedCandidates.map(
          (candidate) => candidate._id,
        );

        const rsp = await deleteCandidateSourcedService(candidateIds);

        if (rsp) {
          dispatch(removeSelectedCandidates(selectedCandidates));
        }

        toast.update(toastId, {
          render: 'Sourced candidates deleted successfully',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        });
      } catch (error) {
        console.error(
          'Error while deleting sourced candidates:',
          error.message,
        );

        toast.update(toastId, {
          render: 'Something went wrong while deleting sourced candidates',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
      }
    }
  };
  const [isDownloadingResumes, setIsDownloadingResumes] = useState(false);

  const downloadSelectedResumes = async () => {
    if (!selectedCandidates || selectedCandidates.length === 0) {
      toast.error('Select at least one candidate to download resumes.');
      return;
    }
    if (isDownloadingResumes) return;

    // Outreached rows come from the sourcing service and have no resume on our side.
    const downloadable =
      activeTab === 'SOURCED'
        ? selectedCandidates.filter((c) => c._tableSource !== 'OUTREACHED')
        : selectedCandidates;
    if (downloadable.length === 0) {
      toast.error('Resumes are not available for the selected candidates.');
      return;
    }

    setIsDownloadingResumes(true);
    const toastId = toast.loading(
      `Preparing resumes for ${downloadable.length} candidate(s)...`,
    );
    try {
      if (activeTab === 'SOURCED') {
        // My Uploads rows carry upload_id + unique_id; sourced rows are keyed by _id.
        await downloadScreenedResumesZipService(
          downloadable.map((c) =>
            c.upload_id
              ? { source: 'MY_UPLOADS', upload_id: c.upload_id, unique_id: c.unique_id }
              : { source: 'SOURCED', id: c._id },
          ),
        );
      } else {
        // Decision Center rows are decision records: their interview id is candidate_id.
        await downloadResumesZipService(
          downloadable.map((c) => c.candidate_id || c.interview_id || c._id),
        );
      }
      toast.update(toastId, {
        render:
          'Resumes downloaded. Extract the zip to get the folder. Candidates without a resume are listed in _not_included.txt.',
        type: 'success',
        isLoading: false,
        autoClose: 5000,
      });
    } catch (error) {
      toast.update(toastId, {
        render: error.message,
        type: 'error',
        isLoading: false,
        autoClose: 4000,
      });
    } finally {
      setIsDownloadingResumes(false);
    }
  };

  const getDisplayStatus = (candidate) => {
    if (candidate?.isRescheduled) return 'Rescheduled';
    if (candidate?.isCanceled) return 'Canceled';
    return candidate?.combined_status || 'N/A';
  };

  const downloadSelectedCandidatesExcel = async () => {
    // Nothing downloads without a selection, on every tab. This runs before the
    // backend export below, which would otherwise export everyone in scope.
    if (!selectedCandidates || selectedCandidates.length === 0) {
      toast.error('Select at least one candidate to download.');
      return;
    }

    // Candidate management screen (My Uploads / Applications Received / All)
    // downloads via the backend.
    if (
      activeTab === 'SOURCED' &&
      ['ALL', 'MY_UPLOADS', 'SOURCED_CANDIDATES'].includes(activeSubTab)
    ) {
      const scope =
        activeSubTab === 'MY_UPLOADS'
          ? 'my_uploads'
          : activeSubTab === 'SOURCED_CANDIDATES'
            ? 'sourced'
            : 'all';

      // My Uploads rows carry unique_id; Applications Received (sourced) rows don't.
      const uniqueIds = selectedCandidates
        .filter((c) => !!c.unique_id)
        .map((c) => c.unique_id);
      const candidateIds = selectedCandidates
        .filter((c) => !c.unique_id)
        .map((c) => c._id);

      const toastId = toast.loading('Preparing Excel file...');
      const success = await exportCandidatesExcelService({
        scope,
        uniqueIds,
        candidateIds,
      });

      if (success) {
        toast.update(toastId, {
          render: 'Download started',
          type: 'success',
          isLoading: false,
          autoClose: 2000,
        });
      } else {
        toast.update(toastId, {
          render: 'Failed to download Excel',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
      }
      return;
    }

    // Column label → candidate object key mapping per tab/subtab
    const COLUMN_KEY_MAP = {
      MY_UPLOADS: {
        'Candidate Name': (c) => c.name,
        'Email Id': (c) => c.candidate_email,
        'Contact Number': (c) => c.contact_number,
        'Uploaded On': (c) =>
          c.uploaded_on ? new Date(c.uploaded_on).toLocaleDateString() : 'N/A',
        'Resume Score': (c) => c.score ?? 'N/A',
      },
      SOURCED_CANDIDATES: {
        'Candidate Name': (c) => c.name,
        'Email Id': (c) => c.candidate_email,
        'Contact Number': (c) => c.mobile,
        'Notice Period': (c) => c.notice_period ?? 'N/A',
        Source: (c) => c.source_of_application ?? 'N/A',
        'Resume Score': (c) => c.score ?? 'N/A',
        'Applied Date': (c) =>
          c.applied_at ? new Date(c.applied_at).toLocaleDateString() : 'N/A',
      },
      OUTREACHED: {
        'Candidate Name': (c) => c.name,
        'Job Role': (c) => c.job_role || 'N/A',
        'Email Id': (c) => c.candidate_email || 'N/A',
        'Contact Number': (c) => c.contact_number || 'N/A',
        // applied_at holds the reply date for outreached rows.
        'Applied On': (c) =>
          c.applied_at ? new Date(c.applied_at).toLocaleDateString() : 'N/A',
        Source: (c) => c.source_of_application ?? 'N/A',
        Sequence: (c) => c.sequence_name ?? 'N/A',
      },
      SCHEDULED: {
        'Candidate Name': (c) => c.candidate_name,
        'Email Id': (c) => c.candidate_email,
        'Contact Number': (c) => c.contact_number,
        'Job Role': (c) => c.jdposition ?? 'N/A',
        'Invited Date': (c) => c.invited_date ?? 'N/A',
        Owner: (c) => c.scheduled_by_name ?? 'N/A',
        'Interview Score': (c) => c.interview_percent ?? 'N/A',
        Status: (c) => getDisplayStatus(c),
      },
      PROGRESS: {
        'Candidate Name': (c) => c.candidate_name,
        'Email Id': (c) => c.candidate_email,
        'Contact Number': (c) => c.contact_number,
        'Job Role': (c) => c.jdposition ?? 'N/A',
        'Invited Date': (c) => c.invited_date ?? 'N/A',
        Owner: (c) => c.scheduled_by_name ?? 'N/A',
        'Interview Score': (c) => c.interview_percent ?? 'N/A',
      },
      COMPLETED: {
        'Candidate Name': (c) => c.candidate_name,
        'Email Id': (c) => c.candidate_email,
        'Contact Number': (c) => c.contact_number,
        'Job Role': (c) => c.jdposition ?? 'N/A',
        'Invited Date': (c) => c.invited_date ?? 'N/A',
        Owner: (c) => c.scheduled_by_name ?? 'N/A',
        'Interview Score': (c) => c.interview_percent ?? 'N/A',
      },
      ACCEPTED: {
        'Candidate Name': (c) => c.candidate_name,
        'Email Id': (c) => c.candidate_email,
        'Contact Number': (c) => c.candidate_number,
        'Interview Date': (c) => c.date_of_interview ?? 'N/A',
        Owner: (c) => c.hr_owner ?? 'N/A',
        'Interview Score': (c) =>
          c.interview_score ? parseFloat(c.interview_score).toFixed(2) : 'N/A',
        Status: (c) => getDisplayStatus(c),
      },
      REJECTED: {
        'Candidate Name': (c) => c.candidate_name,
        'Email Id': (c) => c.candidate_email,
        'Contact Number': (c) => c.candidate_number,
        'Interview Date': (c) => c.date_of_interview ?? 'N/A',
        Owner: (c) => c.hr_owner ?? 'N/A',
        'Interview Score': (c) =>
          c.interview_score ? parseFloat(c.interview_score).toFixed(2) : 'N/A',
        Status: (c) => getDisplayStatus(c),
      },
    };

    if (activeSubTab === 'ALL') {
      let data = [];

      if (activeTab === 'SOURCED') {
        data = selectedCandidates.map((candidate, index) => {
          const isUploaded = !!candidate.upload_id;
          return {
            'Sr. No.': index + 1,
            'Candidate Name':
              candidate.candidate_name || candidate.name || 'N/A',
            'Email Id': candidate.candidate_email ?? 'N/A',
            'Contact Number': String(
              candidate.contact_number || candidate.mobile || '',
            ),
            Date: isUploaded
              ? candidate.uploaded_on
                ? new Date(candidate.uploaded_on).toLocaleDateString()
                : 'N/A'
              : candidate.applied_at
                ? new Date(candidate.applied_at).toLocaleDateString()
                : 'N/A',
            'Notice Period': candidate.notice_period ?? 'N/A',
            Source: isUploaded
              ? 'Uploaded'
              : candidate.source_of_application || 'Sourced',
            'Resume Score': candidate.score ?? 'N/A',
          };
        });
      }

      if (activeTab === 'INTERVIEW') {
        data = selectedCandidates.map((candidate, index) => ({
          'Sr. No.': index + 1,
          'Candidate Name': candidate.candidate_name || 'N/A',
          'Email Id': candidate.candidate_email ?? 'N/A',
          'Contact Number': String(
            candidate.contact_number || candidate.mobile || '',
          ),
          'Job Role': candidate.jdposition ?? 'N/A',
          'Invited Date': candidate.invited_date ?? 'N/A',
          Owner: candidate.scheduled_by_name ?? candidate.hrname ?? 'N/A',
          'Interview Score': candidate.interview_percent ?? 'N/A',
          Status: getDisplayStatus(candidate),
        }));
      }

      if (activeTab === 'DECISION') {
        data = selectedCandidates.map((candidate, index) => ({
          'Sr. No.': index + 1,
          'Candidate Name': candidate.candidate_name || 'N/A',
          'Email Id': candidate.candidate_email ?? 'N/A',
          'Contact Number': String(candidate.candidate_number) ?? 'N/A',
          'Interview Date': candidate.date_of_interview ?? 'N/A',
          Owner: candidate.hr_owner ?? 'N/A',
          'Interview Score': candidate.interview_score
            ? parseFloat(candidate.interview_score).toFixed(2)
            : 'N/A',
          Status: candidate.decision ?? 'N/A',
        }));
      }

      if (data.length === 0) {
        toast.error('No data to download.');
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        `${activeTab}_ALL_Candidates`,
      );

      const colWidths = Object.keys(data[0]).map((key) => ({
        wch: Math.max(key.length + 2, 20),
      }));
      worksheet['!cols'] = colWidths;

      XLSX.writeFile(
        workbook,
        `ALL_candidates_${new Date().toISOString().split('T')[0]}.xlsx`,
      );
      return;
    }

    // Get current tab's column map
    const currentSubTab = activeSubTab; // e.g. "MY_UPLOADS", "SCHEDULED", "ACCEPTED"
    const colMap = COLUMN_KEY_MAP[currentSubTab];

    if (!colMap) {
      toast.error('Download not supported for this tab.');
      return;
    }

    // Get visible columns for current tab from Redux columnVisibility
    const visibleColsConfig =
      columnVisibility?.[activeTab]?.[activeSubTab] ?? [];
    const visibleColLabels = visibleColsConfig
      .filter((colObj) => Object.values(colObj)[0] === true)
      .map((colObj) => Object.keys(colObj)[0]);

    // Build rows using only visible columns
    const data = selectedCandidates.map((candidate, index) => {
      const row = { 'Sr. No.': index + 1 };

      visibleColLabels.forEach((label) => {
        const getter = colMap[label];
        row[label] = getter ? (getter(candidate) ?? 'N/A') : 'N/A';
      });

      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      `${activeSubTab || activeTab}_Candidates`,
    );

    // Auto column width
    const colWidths = Object.keys(data[0]).map((key) => ({
      wch: Math.max(key.length + 2, 20),
    }));
    worksheet['!cols'] = colWidths;

    XLSX.writeFile(
      workbook,
      `${activeSubTab || activeTab}_candidates_${
        new Date().toISOString().split('T')[0]
      }.xlsx`,
    );
  };

  return (
    <div className="relative flex items-center w-fit py-0 my-0 space-x-2">
      <div className="relative flex-1 flex items-center justify-end h-8">
        <Search className="absolute left-3 w-4 h-4 text-gray-400 pointer-events-none" />

        <input
          type="text"
          placeholder="Search by name"
          value={searchQuery}
          autoComplete="off"
          onChange={(e) => {
            dispatch(updateSearchQuery(e.target.value));
            handleDebouncedSearch("");
          }}
          className="pl-10 pr-10 py-1 dark:bg-gray-800/50 bg-bgPrimary border border-gray-500 rounded-full text-sm 
      focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500/50
      dark:text-gray-200 text-textPrimary
      transition-all duration-200 placeholder:text-gray-400"
        />

        {searchQuery && (
          <X
            className="absolute right-3 w-4 h-4 text-gray-400 cursor-pointer hover:text-gray-200 transition-colors"
            onClick={() => {
              dispatch(updateSearchQuery(''));
              handleDebouncedSearch("");
            }}
          />
        )}
      </div>
      <div className="relative group flex items-center" ref={filterRef}>
        <button
          className="relative flex items-center gap-2 dark:glass-effect border
      dark:border-gray-600 border-gray-300 rounded-2xl px-3 py-1
      dark:text-gray-300 text-textSecondary
      dark:hover:bg-gray-700/50 hover:bg-gray-100
      text-sm font-light"
          onClick={() => dispatch(toggleFilterDropdown())}
        >
          <SlidersHorizontal className="w-4 h-4" />

          {filterCount > 0 && (
            <span
              className="absolute -top-1 left-7 bg-gradient-to-r from-pink-500 to-blue-500
        text-white rounded-full w-4 h-4 flex items-center justify-center text-xs"
            >
              {filterCount}
            </span>
          )}
        </button>

        {/* Tooltip */}
        <span
          className="pointer-events-none absolute -top-4 left-8
          opacity-0 group-hover:opacity-100 transition
          dark:bg-gray-900 dark:text-white bg-gray-200 text-xs rounded px-2 py-1 whitespace-nowrap z-50"
        >
          Filters
        </span>
      </div>

      {/* Outreached candidates belong to the sourcing service — there is nothing for
          the ATS delete endpoints to remove, so the action isn't offered there. */}
      {activeTab === 'SOURCED' && activeSubTab !== 'OUTREACHED' && (
        <button
          className={`relative group flex items-center gap-2 dark:glass-effect border rounded-2xl px-3 py-1 text-sm font-light transition-colors
                  ${
                    selectionCount === 0
                      ? 'border-gray-500/40 dark:border-gray-700 text-gray-400/50 dark:text-gray-600  opacity-50  cursor-not-allowed'
                      : 'dark:border-gray-600 border-gray-300 dark:text-gray-300 text-textSecondary dark:hover:bg-gray-700/50 hover:bg-gray-100 cursor-pointer'
                  }`}
          onClick={() => {
            if (selectionCount === 0) {
              toast.error('Select at least one candidate to delete.');
              return;
            }
            dispatch(setShowDeletePopup(true));
          }}
        >
          <Trash2 className="w-4 h-4 dark:text-gray-300 text-textSecondary" />
          <span
            className="pointer-events-none absolute -top-4 left-8
          opacity-0 group-hover:opacity-100 transition
          dark:bg-gray-900 dark:text-white bg-gray-200 text-xs rounded px-2 py-1 whitespace-nowrap z-50"
          >
            Delete
          </span>
        </button>
      )}
      <div className="relative" ref={downloadMenuRef}>
        <button
          className={`relative group flex items-center gap-2 dark:glass-effect border
        dark:border-gray-600 border-gray-300 rounded-2xl px-3 py-1
        dark:text-gray-300 text-textSecondary
        text-sm font-light ${
          isDownloadingResumes
            ? 'opacity-50 cursor-wait'
            : noCandidateSelected
              ? 'opacity-50 cursor-not-allowed'
              : 'dark:hover:bg-gray-700/50 hover:bg-gray-100'
        }`}
          onClick={() => {
            // aria-disabled rather than disabled: a disabled button swallows the click,
            // and this one has to explain why it does nothing.
            if (noCandidateSelected) {
              toast.error('Select at least one candidate to download.', {
                toastId: 'download-no-selection',
              });
              return;
            }
            // Resumes only exist for interview candidates, so only those tabs get the menu.
            if (hasResumeDownload) {
              setShowDownloadMenu((open) => !open);
            } else {
              downloadSelectedCandidatesExcel();
            }
          }}
          aria-disabled={noCandidateSelected}
          disabled={isDownloadingResumes}
        >
          <Download className="w-4 h-4 dark:text-gray-300 text-textSecondary" />
          <span
            className="pointer-events-none absolute z-[999999] -top-4 right-8
          opacity-0 group-hover:opacity-100 transition
          dark:bg-gray-900 dark:text-white bg-gray-200 text-xs rounded px-2 py-1 whitespace-nowrap"
          >
            Download
          </span>
        </button>

        {/* Portaled to <body> with fixed positioning: an ancestor of the toolbar
            clips overflow, which hid an absolutely-positioned menu. */}
        {hasResumeDownload &&
          showDownloadMenu &&
          !noCandidateSelected &&
          createPortal(
            <div
              ref={downloadDropdownRef}
              style={{ position: 'fixed', top: menuPos.top, right: menuPos.right }}
              className="z-[9000] min-w-[11rem] rounded-xl border
          dark:border-gray-600 border-gray-300 dark:bg-gray-900 bg-white shadow-lg py-1"
            >
              <button
                className="w-full flex items-center gap-2 px-3 py-2 text-sm text-left
            dark:text-gray-200 text-textPrimary dark:hover:bg-gray-700/50 hover:bg-gray-100"
                onClick={() => {
                  setShowDownloadMenu(false);
                  downloadSelectedCandidatesExcel();
                }}
              >
                <Download className="w-4 h-4" />
                Candidate Details
              </button>
              <button
                className="w-full flex items-center gap-2 px-3 py-2 text-sm text-left
            dark:text-gray-200 text-textPrimary dark:hover:bg-gray-700/50 hover:bg-gray-100"
                onClick={() => {
                  setShowDownloadMenu(false);
                  downloadSelectedResumes();
                }}
              >
                <FolderDown className="w-4 h-4" />
                {selectedCandidates.length === 1
                  ? 'Candidate Resume'
                  : 'Candidate Resumes'}
              </button>
            </div>,
            document.body,
          )}
      </div>
      <button
        className="relative group flex items-center gap-2 dark:glass-effect border
        dark:border-gray-600 border-gray-300 rounded-2xl px-3 py-1
        dark:text-gray-300 text-textSecondary
        dark:hover:bg-gray-700/50 hover:bg-gray-100
        text-sm font-light"
        onClick={() => dispatch(toggleColFilter())}
      >
        <Layout className="w-4 h-4" />
        <span
          className="pointer-events-none absolute z-[999999] -top-4 right-8
          opacity-0 group-hover:opacity-100 transition
          dark:bg-gray-900 dark:text-white bg-gray-200 text-xs rounded px-2 py-1 whitespace-nowrap"
        >
          Columns
        </span>
      </button>

      {showDeletePopup && (
        <ConfirmationDialog
          open={showDeletePopup}
          onClose={() => dispatch(setShowDeletePopup(false))}
          title="Confirm Deletion"
          message={`Are you sure you want to Delete ${selectedCandidates.length} candidate(s) ?`}
          confirmText="Confirm"
          cancelText="Cancel"
          takeReason={false}
          onConfirm={(reasonText) => {
            handledeletecandidateClicked();
            dispatch(setShowDeletePopup(false));
          }}
        />
      )}
    </div>
  );
}

export default FilterComponent;
